import { EVENT } from "@/constants/event";
import useRequest from "@/utils/useReq";
import { useMount } from "ahooks";
import Link from "next/link";
import HBEmpty from "../components/HBEmpty";
import { getRecommends } from "../services";
import styles from "./index.module.less";
export default function NotFound() {
  const { data } = useRequest(getRecommends);
  useMount(() => {
    window.dispatchEvent(new Event(EVENT.MODAL_PREVIEW_CLOSE));
  });
  const imgs = data?.imgs || [];

  const onSearch = () => {
    document.getElementById("hb_search_input").click();
  };

  return (
    <div
      className={styles.notfound}
      data-gd-expose="dialog_expose"
      data-dialog-title="404页面不存在"
    >
      <HBEmpty
        image="//cdn.dancf.com/fe-assets/img/b6574f8d7ee91f21094691f3ff13d5a9.svg"
        title="Oh~抱歉，访问的页面不存在"
        subtitle="地址有误或该地址已被删除"
      />
      <div className={styles.link}>
        <Link href="/discovery">返回发现页</Link>
        <span>|</span>
        <a onClick={onSearch}>搜索感兴趣的内容</a>
      </div>
      <div className={styles.recommend}>
        <div className={styles.desc}>花瓣为你推荐</div>
        <div className={styles.list}>
          {imgs.slice(0, 3).map((img) => (
            <a
              key={img?.url}
              href={img?.url}
              target="_blank"
              className={styles.item}
              rel="noreferrer"
            >
              <div className={styles.img}>
                <img alt="为你推荐" src={img?.image?.url} loading="lazy" />
              </div>
              <div className={styles.title}>{img?.des}</div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
